﻿import React from 'react';

class CheckList extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {

        return (
            <ul className="checklist__list checklist__list--small stack-small">
                {
                    this.props.listItems.map((text, idx) => {
                        return <li className="checklist__list-item" key={idx}>
                            <div className="checklist__list-item__checkmark">
                                <svg focusable="false" width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><path fill="none" stroke="#000" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="2" d="M13 5l-6 6-4-4"></path></svg>
                            </div>
                            {text}
                        </li>
                    })
                }
            </ul>
        )
    }
}

export default CheckList;